<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Campaña</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <campaign-form
          v-if="isDataLoaded"
          :campaign="campaign"
          :with-crops="false"
          @save="saveCampaign"
        ></campaign-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CampaignForm from './Forms/CampaignForm';
import swal from 'sweetalert2';

export default {
  name: 'CampaignsEdit',
  components: {
    RouteBreadCrumb,
    CampaignForm,
  },

  data() {
    return {
      campaign: null,
      isDataLoaded: false,
    };
  },

  created() {
    const campaignId = this.$route.params.id;
    this.fetchCampaign(campaignId);
  },

  methods: {
    fetchCampaign(id) {
      this.$services
        .resource('campaigns')
        .show(id)
        .then((res) => res.data.data)
        .then((campaign) => {
          this.campaign = campaign;
          this.isDataLoaded = true;
        });
    },

    saveCampaign(campaign) {
      this.$services
        .resource('campaigns')
        .update(this.campaign.id, campaign)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'La campaña fue editada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'CampaignsList' }));
        });
    },
  },
};
</script>
